import { DialogActions, DialogContent, Grid } from "@mui/material";
import DialogHESP from "../DialogHESP/DialogHESP";
import DialogFooterWithLoading from "../Loading/DialogFooterWithLoading";
import React from "react";
import gql from "graphql-tag";
import { useMutation } from "react-apollo";

import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../BillingDetails/AddPaymentMethodDialog";

import { GET_DATACENTER } from "../../views/App/TLADatacenter";
import {
    DeleteInstallContextMutation,
    DeleteInstallContextMutationVariables,
} from "./__generated__/DeleteInstallContextMutation";

interface Props {
    open: boolean;
    installContextId: string;
    datacenterId: string;
    name: string;
    onClose: () => void;
}

export const REMOVE_TLA_INSTALL_CONTEXT = gql`
    mutation DeleteInstallContextMutation($input: DeleteInstallContextInput!) {
        deleteInstallContext(input: $input)
    }
`;

export default function TLARemoveInstallContextDialog({ onClose, open, installContextId, datacenterId, name }: Props) {
    const [removeInstallContext, { loading }] = useMutation<
        DeleteInstallContextMutation,
        DeleteInstallContextMutationVariables
    >(REMOVE_TLA_INSTALL_CONTEXT);

    async function onConfirm() {
        try {
            await removeInstallContext({
                variables: {
                    input: {
                        id: installContextId,
                    },
                },
                refetchQueries: [
                    {
                        query: GET_DATACENTER,
                        variables: {
                            id: datacenterId,
                        },
                    },
                ],
            });
            onClose();
        } catch (e) {
            toast.error("Error while removing install context", TOAST_SETTINGS);
        }
    }

    return (
        <DialogHESP
            title={"Remove install context"}
            open={open}
            onClose={onClose}
            content={
                <>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} style={{ marginTop: "14px" }}>
                                Are you sure you want to remove install context "{name}"?
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <DialogFooterWithLoading
                            isLoading={loading}
                            onCancelClick={onClose}
                            onActionClick={onConfirm}
                            defaultText={"Remove"}
                            loadingText={"Removing..."}
                        />
                    </DialogActions>
                </>
            }
        />
    );
}
